export const TIMEZONE_UTC = 'utc';
export const TIMEZONE_LOCAL = 'local';
export const TIMEZONE_UTC_MUI = 'UTC';
export const TIMEZONE_SYSTEM_MUI = 'system';
export const TIMEZONE_LS_KEY = 'awTimezone';
export const AVAILABLE_TIMEZONES = [TIMEZONE_LOCAL, TIMEZONE_UTC] as Timezone[];
export const TIMEZONE_TO_MUI: Record<Timezone, TimezoneMui> = {
  [TIMEZONE_LOCAL]: TIMEZONE_SYSTEM_MUI,
  [TIMEZONE_UTC]: TIMEZONE_UTC_MUI,
};
export type Timezone = typeof TIMEZONE_UTC | typeof TIMEZONE_LOCAL;
export type TimezoneMui = typeof TIMEZONE_SYSTEM_MUI | typeof TIMEZONE_UTC_MUI;
